import { CustomDateObject } from '../shared/types'

const getDateStringFromCustomDate = (customDate: CustomDateObject) => {
  let dateString = ''
  if (customDate.day && customDate.month) {
    dateString += `${customDate.day < 10 ? '0' + customDate.day : customDate.day}.${customDate.month < 10 ? '0' + customDate.month : customDate.month}.`
  }
  if (customDate.year) {
    dateString += customDate.year
  }
  return dateString
}

export default getDateStringFromCustomDate
